import cx from "classnames";

import styles from "../styles.module.css";

type RadioIconProps = {
  checked?: boolean;
  disabled?: boolean;
};

/** The radio's look without an input, for an element that already has the radio role */
const RadioIcon = ({ checked, disabled }: RadioIconProps) => (
  <span
    className={cx(styles.radioWrapper, {
      [styles.checked]: checked,
      [styles.disabled]: disabled,
    })}
    aria-hidden
  >
    <span className={styles.radio}>
      <span className={styles.dot} />
    </span>
  </span>
);

RadioIcon.displayName = "DS.Radio.Icon";

export default RadioIcon;
